import React from "react";
import { Container, Spinner } from "react-bootstrap";
import "./Loading.css";

function Loading({ message = "Loading..." }) {
  return (
    <div className="loading-overlay">
      <Container className="loading-container">
        <div className="loading-content">
          <Spinner
            animation="border"
            role="status"
            variant="light"
            className="loading-spinner"
          />
          <p className="loading-text">{message}</p>
        </div>
      </Container>
    </div>
  );
}

export default Loading;
